import * as t from 'io-ts';

import {
  RAnalyticsDetailsConversationDirty,
  RAnalyticsDetailsConversationsDirty,
} from '../../../../models/api/analyticsMetricDetailsModel';
import {RAnalyticsMetricsKeysDirty} from '../../../../models/api/analyticsMetricsModel';
import {RAnalyticsReportFilterOptionsDirty} from '../../../../models/api/analyticsSavedViewModel';

/*
 * Runtime types.
 */

export const RAnalyticsPanelDetailsStateDirty = t.type({
  selectedMetric: t.union([t.undefined, RAnalyticsMetricsKeysDirty]),
  customLabel: t.union([t.undefined, t.string]),
  options: t.union([t.undefined, RAnalyticsReportFilterOptionsDirty]),
  conversations: RAnalyticsDetailsConversationsDirty,
  error: t.union([t.undefined, t.string]),
  isLoading: t.boolean,
  isSidePanelOpen: t.boolean,
  isConversationDetailsSidePanelOpen: t.boolean,
  selectedConversation: t.union([t.undefined, RAnalyticsDetailsConversationDirty]),
  conversationsPageNumber: t.number,
});

/*
 * Types.
 */

export interface AnalyticsPanelDetailsState
  extends Readonly<t.TypeOf<typeof RAnalyticsPanelDetailsStateDirty>> {}
